import { render, staticRenderFns } from "./TextStyleDefinition.vue?vue&type=template&id=cdb2d818&scoped=true"
import script from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
export * from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
import style0 from "./TextStyleDefinition.vue?vue&type=style&index=0&id=cdb2d818&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2d818",
  null
  
)

export default component.exports